<div class="container">
  <pdq-card color="white">
    <div class="card-content">
      <p
        class="template__description"
        [innerHtml]="
          recipeTemplate?.description | variablePlaceholders: recipeTemplate?.dynamicPartsConfig?.variables : false
        "></p>
      <footer>
        <pdq-button
          [disabled]="!integrationsService.isConnected(integrationType?.name)"
          [loading]="isLoading"
          (onClick)="addRecipe()"
          >Add to your recipes</pdq-button
        >
      </footer>
    </div>
  </pdq-card>
</div>
